import React from 'react';
import VerticalPad from './VerticalPad';
import { useThemeColors } from '../ThemeContext';

const SectionFeatures: React.FC = () => {
  const theme = useThemeColors();
  return (
    <section id="features" className="py-5" style={{ backgroundColor: theme.featureSectionBackground }}>
      <VerticalPad height={30} />
      <div className="container">
        <h2 className="text-center mb-4 text-white" style={{ fontSize: '48px' }}>Programmable Phone Agents<br /><i style={{ color: theme.featureSubHeadline }}>Automate Tasks Effortlessly</i></h2>
        <VerticalPad height={60} />
        <div className="row justify-content-center" style={{ display: 'flex', flexWrap: 'wrap' }}>
          {[
            {
              icon: (
                <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
              ),
              title: "Dynamic Call Routing",
              description: "Route calls to personnel based on predefined conditions."
            },
            {
              icon: (
                <>
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </>
              ),
              title: "Message Handling",
              description: "Take messages and automatically forward emails to the respective department."
            },
            {
              icon: (
                <>
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                  <line x1="12" y1="19" x2="12" y2="23"></line>
                  <line x1="8" y1="23" x2="16" y2="23"></line>
                </>
              ),
              title: "Custom Voice Selection",
              description: "Choose from a curated voice library or personalize with a voice clone."
            },
            {
              icon: (
                <>
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                </>
              ),
              title: "Software Integration",
              description: "Connect with CRMs and rosters to make appointments or fill shifts when someone is sick."
            }
          ].map((item, index) => (
            <div key={index} className="col-md-3" style={{ display: 'flex', marginBottom: '20px' }}>
              <div className="bg-white rounded" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', height: '100%', width: '100%', padding: '24px', minWidth: '200px', color: theme.featureText }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke={theme.featureText} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '40px', height: '40px', backgroundColor: 'transparent', opacity: 0.8, marginBottom: '16px' }}>
                  {item.icon}
                </svg>
                <h3 style={{ fontSize: '36px', marginBottom: '20px', textAlign: 'left', color: theme.featureText }}>{item.title}</h3>
                <p style={{ fontSize: '18px', marginBottom: '0', textAlign: 'left', color: theme.featureText }}>{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <VerticalPad height={80} />

        <div className="row">
          <div className="col-md-6">
            <div style={{
              backgroundColor: 'white',
              borderRadius: '15px',
              padding: '30px',
              position: 'relative',
              overflow: 'hidden',
              backgroundImage: `
                linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 50%),
                linear-gradient(to top, rgba(255,255,255,0), rgba(255,255,255,1)),
                url("/office-scene.jpg")
              `,
              backgroundSize: '100% 60%, 100% 100%, auto 60%',
              backgroundPosition: 'center bottom, center center, right bottom',
              backgroundRepeat: 'no-repeat',
            }}>
              <h2 className="mb-4" style={{ fontSize: '48px', color: '#333', borderBottom: `2px solid ${theme.featureText}`, paddingBottom: '10px', position: 'relative', zIndex: 1 }}>A versatile solution for all industries.</h2>
              <p className="mb-3" style={{ fontSize: '18px', color: '#333', position: 'relative', zIndex: 1 }}>From personal assistants to receptionists, streamline communications across:</p>
              <div style={{ fontSize: '18px', paddingLeft: '40px', lineHeight: '2', marginBottom: '30px', color: '#333', position: 'relative', zIndex: 1 }}>
                {['Healthcare', 'Real Estate', 'Logistics', 'Financial Services', 'Alternative Data', 'Small Businesses'].map((item, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', border: '2px solid #333', borderRadius: '4px', marginRight: '10px', fontSize: '18px' }}>✓</span>
                    <span style={{ fontWeight: '600' }}>{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <VerticalPad height={60} />
          </div>
          <div className="col-md-6">
            {[
              {
                number: "01",
                title: "Receptionist",
                description: "Optimize your operations with our AI phone agents that are designed to deliver exceptional product service and support around the clock.",
                icon: (
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                )
              },
              {
                number: "02",
                title: "Product Service",
                description: "Deliver exceptional product support with AI web and phone agents that seamlessly integrate with your systems, ensuring efficient inquiry resolution while maintaining your brand’s identity.",
                icon: (
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                )
              },
              {
                number: "03",
                title: "Appointment Scheduling",
                description: "Streamline your appointment scheduling with our AI phone agents ensuring efficient calendar management and timely reminders for optimal client engagement.",
                icon: (
                  <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                )
              }
            ].map((item, index) => (
              <div key={index} className="mb-4">
                <div className="rounded overflow-hidden">
                  <div className="d-flex">
                    <div className="text-white font-weight-bold d-flex align-items-center justify-content-center" style={{ width: '50px', padding: '12px', background: theme.featureCardHeaderNumberBackground }}>
                      {item.number}
                    </div>
                    <div className="text-white flex-grow-1 d-flex align-items-center" style={{ padding: '12px', background: theme.featureCardHeaderTitleBackground }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={theme.featureCardHeaderNumberBackground} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" style={{ marginLeft: '3px', marginRight: '13px' }}>
                        {item.icon}
                      </svg>
                      <h3 className="mb-0" style={{ fontSize: '24px' }}>{item.title}</h3>
                    </div>
                  </div>
                  <div className="bg-white" style={{ padding: '20px' }}>
                    <p style={{ fontSize: '18px', marginBottom: '0', textAlign: 'left', color: theme.featureText }}>{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionFeatures;